<template>
  <div>
    <!-- <v-card flat class="mb-15"> -->
    <v-data-table
      :headers="headers"
      :items="products"
      :search="search"
      @click:row="selectUpdateObject"
      class="border-2"
      :loading="isLoading"
      :no-data-text="$t('noinfo')"
      :no-results-text="$t('no_matching_records_found')"
    >
      <template v-slot:item.objectId="{ item }">
        <div class="justify-end d-flex">
          <v-btn
            text
            color="yellow darken-2"
            @click="selectUpdateObject(item)"
          >
            <v-icon left>mdi-pencil</v-icon>{{$t('action_type.edit') }}
          </v-btn>
          <v-btn
            text
            color="error"
            @click.stop="dialogRemoveProduct(item)"
          >
            <v-icon left>mdi-trash-can-outline</v-icon>{{ $t('action_type.delete') }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <!-- </v-card> -->
    <form-product
      v-model="updateDialog"
      :obj="updateObject"
      event="edit"
      @onUpdated="$emit('onLoad')">
    </form-product>
    <ConfirmDialog
      v-if="tempProduct"
      type="error"
      v-model="isDialogRemveProduct"
      @onOk="removeProduct"
      :text="`${$t('validate.want_to_delete')} ${tempProduct.name} (${tempProduct.name_en})`" />
  </div>
</template>

<script>
import FormProduct from "./FormProduct.vue";
import ConfirmDialog from "./ConfirmDialog.component"
import { mapActions, mapGetters } from "vuex";
import { create } from "sortablejs";
export default {
  components: {
    FormProduct,
    ConfirmDialog
  },
  name: "Products",
  computed: {
    ...mapGetters({
      products: "product/getProducts",
      getProjectId: "markets/getProjectId",
      getProductTotal: "product/getProductTotal",
    }),
  },
  mounted() { },
  data() {
    return {
      headers: [],
      updateDialog: false,
      updateObject: {},
      isDialogRemveProduct: false,
      tempProduct: null,
      isLoading: false,
      isError: false,
    };
  },
  props: {
    search: String,
  },
  methods: {
    selectUpdateObject(obj) {
      this.updateObject = obj;
      this.updateDialog = true;
    },
    dialogRemoveProduct(product) {
      this.tempProduct = product
      this.isDialogRemveProduct = true
    },
    async removeProduct() {
      this.isLoading = true
      try {
        await this.$store.dispatch("product/removeProduct", this.tempProduct.objectId)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.isError = true
      }
    }
  },
  created() {
    this.headers = [
      {
        text: this.$t('product.product_code'),
        value: "erpId",
      },
      {
        text: this.$t('product.product_name'),
        value: "name",
      },
      {
        text: this.$t('product.product_category'),
        value: "productCategoryLabel",
      },
      {
        text: "",
        value: "objectId",
      },
    ]
  }
};
</script>

<style lang="scss" scoped>
.text-start {
  border-right: 1px solid #eee;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}
</style>
